'use client';

import { useState } from 'react';
import {
    Button,
    DataTable,
    Modal,
    ModalContent,
    P,
} from '@paypoteam/ui-components';

import { INSTALLMENTS_MODAL_CONFIG as config } from '@/static/content/pl/installments-modal';

const InstallmentsModal = () => {
    const [isInstallmentsModalVisible, setInstallmentsModalVisible] =
        useState(false);

    const { title, subtitle, tables } = config;

    const handleClose = () => {
        setInstallmentsModalVisible(false);
    };

    return (
        <>
            <Button
                size={'m'}
                onClick={() =>
                    setInstallmentsModalVisible(!isInstallmentsModalVisible)
                }
                variant={'primary'}
                className="mx-auto mt-4 w-full sm:max-w-[230px] md:mt-0"
                data-test-id="modal-icon-pointer-list-button"
            >
                Zobacz szczegóły
            </Button>

            {!!isInstallmentsModalVisible && (
                <Modal
                    open={isInstallmentsModalVisible}
                    onOpenChange={handleClose}
                >
                    <ModalContent
                        title={title}
                        isFullOnMobile
                    >
                        <P
                            className="mb-4"
                            size="xs"
                        >
                            {subtitle}
                        </P>

                        {tables.map(({ tableProps, id }) => (
                            <DataTable
                                key={id + 1}
                                containerClassName="mb-4"
                                {...tableProps}
                            />
                        ))}
                    </ModalContent>
                </Modal>
            )}
        </>
    );
};

export default InstallmentsModal;
